import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

interface PageContainerProps {
  children?: React.ReactNode;
  env: Env;
  initialCurrentUser?: User;
  isNativeApp?: boolean;
  isWebview: boolean;
  nativeAppVersion?: string;
  showBookmarksFlagEnabled?: boolean;
}

const queryClient = new QueryClient();

const PageContainer = ({
  children,
  env,
  initialCurrentUser,
  isNativeApp,
  isWebview,
  nativeAppVersion,
  showBookmarksFlagEnabled,
}: PageContainerProps): JSX.Element => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isNativeApp={isNativeApp}
      isWebview={isWebview}
      nativeAppVersion={nativeAppVersion}
      showBookmarksFlagEnabled={showBookmarksFlagEnabled}
    >
      <QueryClientProvider client={queryClient}>
        <main className="px-0 sm:px-28">
          <div className="m-auto max-w-container-lg">{children}</div>
        </main>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default PageContainer;
